/* Les lecteurs vidéo ne sont chargés qu'après une action explicite. */
(function(){
 if(window.__guildeCanyonVideoBridge)return;
 window.__guildeCanyonVideoBridge=true;
 document.addEventListener('click',function(event){
  if(event.defaultPrevented||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0||!(event.target instanceof Element))return;
  var link=event.target.closest('[data-guild-video],[data-gdc-video],[data-gdc-play]');
  if(!link||!link.isConnected)return;
  if(link.hasAttribute('data-gdc-play')){
   var holder=link.closest('.gdc-film');
   var template=holder&&holder.querySelector('template');
   if(!template)return;
   event.preventDefault();holder.replaceChildren(template.content.cloneNode(true));
   var embedded=holder.querySelector('iframe');
   if(embedded){embedded.tabIndex=0;embedded.focus();}return;
  }
  var id=link.getAttribute('data-guild-video')||link.getAttribute('data-gdc-video');
  if(!/^[A-Za-z0-9_-]{11}$/.test(id||''))return;
  event.preventDefault();
  var frame=document.createElement('iframe');
  frame.className=link.hasAttribute('data-guild-video')?'guild-video-frame':'gdc-video-frame';
  frame.title=link.getAttribute('data-video-title')||'Film de la Guilde du Chardon';
  frame.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
  frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.tabIndex=0;
  link.replaceWith(frame);frame.focus();
 });
})();
